function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ui-event-menu-sidebar");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 940,
  height: 124
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "background",
  x: 0,
  y: 0,
  width: 950,
  height: 500,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "ui-event-menu-sidebar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_image_bg",
  transform: "translate(0.000000, 45.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#defaultColor",
  fillRule: "nonzero",
  xlinkHref: "#path-1",
  className: "primaryLight"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 174,
  y: 111,
  width: 150,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 191,
  y: 240,
  width: 530,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 191,
  y: 257,
  width: 530,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 191,
  y: 274,
  width: 530,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 191,
  y: 291,
  width: 530,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 191,
  y: 309,
  width: 530,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 191,
  y: 326,
  width: 530,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 191,
  y: 343,
  width: 300,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 191,
  y: 204,
  width: 112,
  height: 14,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 191,
  y: 414,
  width: 112,
  height: 14,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 174,
  y: 144,
  width: 50,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 174,
  y: 76,
  width: 296,
  height: 24,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-3",
  fill: "#24C0DC",
  fillRule: "nonzero",
  x: 793,
  y: 199,
  width: 131,
  height: 100,
  rx: 4,
  className: "secondary"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-3",
  fill: "#0C5170",
  fillRule: "nonzero",
  x: 793,
  y: 306,
  width: 131,
  height: 100,
  rx: 4,
  className: "primary"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-3",
  stroke: "#24C0DC",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 793.5,
  y: 414.5,
  width: 130,
  height: 99,
  rx: 4,
  className: "secondaryButton"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8",
  stroke: "#24C0DC",
  x: 725.5,
  y: 12.5,
  width: 55,
  height: 19,
  rx: 9.5,
  className: "secondary"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8",
  stroke: "#24C0DC",
  x: 790.5,
  y: 12.5,
  width: 92,
  height: 19,
  rx: 9.5,
  className: "secondary"
}), /*#__PURE__*/React.createElement("text", {
  id: "Rooms",
  fontFamily: "Karla-Bold, Karla",
  fontSize: 11,
  fontWeight: "bold",
  fill: "#24C0DC"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 735.114,
  y: 24
}, "Rooms")), /*#__PURE__*/React.createElement("text", {
  id: "Manage-Event",
  fontFamily: "Karla-Bold, Karla",
  fontSize: 11,
  fontWeight: "bold",
  fill: "#24C0DC"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 799.7435,
  y: 24
}, "Manage Event")), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-6",
  fill: "#117BAD",
  fillRule: "nonzero",
  cx: 912,
  cy: 22,
  r: 12,
  className: "primary"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-6",
  fill: "#117BAD",
  fillRule: "nonzero",
  cx: 453,
  cy: 488,
  r: 34,
  className: "primary"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-6",
  fill: "#117BAD",
  fillRule: "nonzero",
  cx: 23,
  cy: 21,
  r: 9,
  className: "primary"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8",
  fill: "#24C0DC",
  x: 836,
  y: 485,
  width: 45,
  height: 20,
  rx: 10,
  className: "secondary"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8",
  fill: "#FFFFFF",
  x: 821,
  y: 262,
  width: 76,
  height: 20,
  rx: 10
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8",
  fill: "#24C0DC",
  x: 810,
  y: 369,
  width: 98,
  height: 20,
  rx: 10,
  className: "secondary"
}), /*#__PURE__*/React.createElement("text", {
  id: "Go",
  fontFamily: "Karla-Bold, Karla",
  fontSize: 11,
  fontWeight: "bold",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 852.1635,
  y: 498
}, "Go")), /*#__PURE__*/React.createElement("text", {
  id: "Get-your-tickets",
  fontFamily: "Karla-Bold, Karla",
  fontSize: 11,
  fontWeight: "bold",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 817.2445,
  y: 382
}, "Get your tickets")), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 809,
  y: 220,
  width: 100,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 809,
  y: 327,
  width: 100,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 809,
  y: 236,
  width: 100,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 809,
  y: 343,
  width: 100,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 809,
  y: 428,
  width: 100,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 809,
  y: 442,
  width: 100,
  height: 35,
  rx: 6
}), /*#__PURE__*/React.createElement("text", {
  id: "Leave-Event",
  fontFamily: "Karla-Bold, Karla",
  fontSize: 11,
  fontWeight: "bold",
  fill: "#24C0DC",
  className: "secondary"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 828.9035,
  y: 276
}, "Leave Event")), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#24C0DC",
  fillRule: "nonzero",
  x: 10,
  y: 229,
  width: 18,
  height: 9,
  rx: 4.5,
  className: "secondary"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 10,
  y: 249,
  width: 37,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 10,
  y: 269,
  width: 44,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 10,
  y: 289,
  width: 44,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 10,
  y: 308,
  width: 56,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 10,
  y: 328,
  width: 30,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 10,
  y: 348,
  width: 30,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#D7D7D7",
  fillRule: "nonzero",
  x: 10,
  y: 368,
  width: 60,
  height: 9,
  rx: 4.5
}));

var SvgUiEventMenuSidebar = function SvgUiEventMenuSidebar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "940px",
    height: "540px",
    viewBox: "0 0 940 540",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUiEventMenuSidebar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/uiEventMenuSidebar.cfbe0e19.svg";
export { ForwardRef as ReactComponent };